import script from "./DemoBaoDuongChat.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoBaoDuongChat.vue?vue&type=script&setup=true&lang=js"

import "./DemoBaoDuongChat.vue?vue&type=style&index=0&id=63446024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63446024"]])

export default __exports__